import { render, staticRenderFns } from "./message-editable.vue?vue&type=template&id=cf844e16&"
import script from "./message-editable.vue?vue&type=script&lang=js&"
export * from "./message-editable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports